import { useStore } from "@store"

const useAllUsers = () => {
  const { allUserStore } = useStore()

  return allUserStore.state.data
}

export default useAllUsers
